export enum Theme {
  Default = "default-dsfr",
  LightBlue = "light-blue",
  BordeauxMetropole = "bordeaux-metropole",
  Soliguide = "soliguide",
  VilleDeVannes = "ville-de-vannes",
}

export enum ThemeLabel {
  Default = "Thème bleu foncé (DSFR)",
  LightBlue = "Thème bleu clair",
  BordeauxMetropole = "Thème Bordeaux Métropole",
  Soliguide = "Thème Soliguide",
  VilleDeVannes = "Thème Ville de Vannes",
}
